import React from "react"

const ErrorIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path d="M3.99128 6.26217C5.80154 3.05897 6.70667 1.45736 7.9487 1.04508C8.63198 0.818274 9.36802 0.818274 10.0513 1.04508C11.2933 1.45736 12.1985 3.05897 14.0087 6.26217C15.819 9.46538 16.7241 11.067 16.4526 12.372C16.3032 13.0899 15.9352 13.7411 15.4013 14.2322C14.4308 15.125 12.6205 15.125 9 15.125C5.37949 15.125 3.56923 15.125 2.59872 14.2322C2.06481 13.7411 1.69679 13.0899 1.54742 12.372C1.2759 11.067 2.18102 9.46538 3.99128 6.26217Z" stroke="#B60C02" stroke-width="1.5" />
            <path d="M8.994 11H9.00073" stroke="#B60C02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 8.74998L9 5.74998" stroke="#B60C02" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default ErrorIcon